import { getExtraGraphDataArr } from "entity/LaudoVisita/functions"
import { Cell, Pie, PieChart } from "recharts"

export default function PerdasGraficoExtraPainel({ indicadorProps, nomeAgrupador }) {
    const RADIAN = Math.PI / 180

    const PieCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, payload }) => {
        // 1.6 é a distância dos labels do centro do gráfico
        const radius = innerRadius + (outerRadius - innerRadius) * 1.6
        const x = cx + radius * Math.cos(-midAngle * RADIAN)
        const y = cy + radius * Math.sin(-midAngle * RADIAN)

        return (
            <text
                x={x}
                y={y}
                fill={payload.fill}
                textAnchor={x > cx ? 'start' : 'end'}
                dominantBaseline="central"
            >
                {`${payload.label} (${(percent * 100).toFixed(2)}%)`}
            </text>
        )
    }

    return (
        <PieChart width={730} height={200}>
            <Pie
                data={getExtraGraphDataArr(indicadorProps)}
                dataKey="percentage"
                nameKey="label"
                cx="50%"
                cy="50%"
                outerRadius={50}
                fill="#8884d8"
                label={<PieCustomizedLabel />}
            >
                {getExtraGraphDataArr(indicadorProps).map((entry, index) => {
                    return (<Cell key={`cell-${index}`} fill={entry.color} />)
                })}
            </Pie>
        </PieChart>
    )
}